import React from 'react'
import styled from 'styled-components'

export const Img = styled.img`
  border-style: none;
  max-width: 100%;
`
